import { Button } from '@mui/material';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import { useWebshop } from 'hooks/useWebshop';
import { colors } from 'styles/theme/colors';
import { useServerTranslation } from 'hooks/useServerTranslation';

type AddToCartButtonProps = {
    onClick: () => void;
    disabled?: boolean;
    isAddedToCart?: boolean;
};

export function AddToCartButton(props: AddToCartButtonProps) {
    const {
        onClick,
        disabled = false,
        isAddedToCart,
    } = props;

    const { isPurchaseDisabled } = useWebshop();
    const { t } = useServerTranslation();

    if (isPurchaseDisabled) {
        return null;
    }

    return (
        <Button
            fullWidth
            variant="contained"
            startIcon={<ShoppingBasketIcon />}
            onClick={onClick}
            disabled={disabled}
            sx={{ minWidth: '150px', color: colors.pink2 }}
        >
            {isAddedToCart ? t('common.button.update-product-in-cart') : t('common.button.add-to-cart')}
        </Button>
    );
}
